import querystring from 'querystring';
import { getAbsoluteUrl } from "./microApp";
export function isNewWorkbenchEnabled() {
  return localStorage.getItem('xy_new_workbench_enabled') === '1';
}
export function getDatabaseUrlForNewUI(appId, schemaId) {
  var _window$xy_vue_instan;
  let {
    branch: branchId,
    projectid: projectId
  } = ((_window$xy_vue_instan = window.xy_vue_instance) === null || _window$xy_vue_instan === void 0 || (_window$xy_vue_instan = _window$xy_vue_instan.$route) === null || _window$xy_vue_instan === void 0 ? void 0 : _window$xy_vue_instan.query) || {};
  if (!branchId || !projectId) {
    const {
      branch,
      projectid
    } = querystring.parse(window.location.search.replace('?', ''));
    branchId = branch;
    projectId = projectid;
  }
  const params = new URLSearchParams();
  params.append('projectid', projectId);
  if (branchId) {
    params.append('branch', branchId);
  }
  params.append('appid', appId);
  params.append('schemaid', schemaId);
  return getAbsoluteUrl(`/xy/workbench/data-and-log/database?${params.toString()}`);
}
export function getDatabaseUrl(appId, schemaId) {
  const isNewUI = isNewWorkbenchEnabled();
  if (!isNewUI) {
    return getAbsoluteUrl(`/p/edit?appid=${appId}&schemaid=${schemaId}`);
  }
  return getDatabaseUrlForNewUI(appId, schemaId);
}
//# sourceMappingURL=workbench.js.map
